import { authAxios } from '../utility/axios';

export const getPublications = (params) => {
  return authAxios.get('/wall', { params })
    .then(({ data }) => data);
};